export default __webpack_public_path__ + "media/zurb/img/icons/services/growth-7eb4d47003bc95c26177fdf76edd4a4e.svg";